import { $$, addEventListenerAll } from '../../helper/utils';

// function substractRow(rows, lineHeight) {
//   const elHeightToScrollHeightDiff = this.scrollHeight - this.clientHeight;

//   console.log(elHeightToScrollHeightDiff);
//   if (elHeightToScrollHeightDiff < lineHeight) {
//     this.rows -= 1;

//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         substractRow.call(this, lineHeight);
//       });
//     });
//   }
// }

function textareaCounter() {
  const textareas = $$('main textarea[maxlength]');

  if (textareas.length === 0) {
    return;
  }

  const textareasRows = new Map();
  const styles = getComputedStyle(textareas[0]);
  const textareasStyleObj = {
    lineHeight: parseInt(styles.lineHeight, 10),
    paddingTopBottom: parseInt(styles.paddingTop, 10) + parseInt(styles.paddingBottom, 10),
  };

  for (const ta of textareas) {
    textareasRows.set(ta, ta.rows);
  }

  console.log(textareas);
  addEventListenerAll(textareas, 'input', function (e) {
    const charsCounter = this.parentElement.querySelector('.chars');

    if (!charsCounter || this.scrollHeight < this.clientHeight) {
      return;
    }

    const rows = textareasRows.get(this);
    const elHeightToScrollHeightDiff = this.scrollHeight - this.clientHeight;
    // const extraRows = elHeightToScrollHeightDiff < textareasStyleObj.lineHeight ? -1 : (
    //   Math.round(elHeightToScrollHeightDiff / textareasStyleObj.lineHeight));
    const extraRows = Math.round(elHeightToScrollHeightDiff / textareasStyleObj.lineHeight);
    const currentRows = Math.round(
      (this.clientHeight - textareasStyleObj.paddingTopBottom) / textareasStyleObj.lineHeight,
    );

    console.log([
      this.clientHeight,
      this.scrollHeight,
      elHeightToScrollHeightDiff,
      textareasStyleObj.lineHeight,
      extraRows,
      currentRows,
    ]);

    this.rows += extraRows;

    charsCounter.textContent = this.maxLength - this.value.length;
  });
}

textareaCounter();
